import React, { useEffect } from "react";
import { Loader } from "cxa-components";
import { useSelector } from "react-redux";
import { getDomainName } from "../../utils";

const QRRedirectOS = () => {
  const env = window.CXAApollo.ENV;
  const clientName = useSelector(state => state.app.clientName);
  useEffect(() => {
    const androidUrl = "https://play.google.com/store/apps/details?id=com.pacificprimecxa.android";
    const customAndroidScheme =
      env === "prod"
        ? `ppcxa://client/${clientName}`
        : `ppcxa://server/${env}/client/${clientName}`;
    const domainName = getDomainName();
    const iosUrl = `https://ios${domainName}/client?id=${clientName}`;
    const iosUrlWithEnv = env === "prod" ? iosUrl : `${iosUrl}&env=${env}`;

    const userAgent = navigator.userAgent || window.opera;
    let timeoutId;

    if (/android/i.test(userAgent)) {
      window.location.href = customAndroidScheme;
      timeoutId = setTimeout(() => {
        window.location.href = androidUrl;
      }, 3000); // Adjust delay as needed
    } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
      window.location.href = iosUrlWithEnv;
    }

    // Clear the timeout if the page is hidden (app has been opened)
    document.addEventListener("visibilitychange", function() {
      if (document.hidden) {
        clearTimeout(timeoutId);
      }
    });

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange");
    };
  }, []);

  return <Loader />; // Show a loader while redirecting
};

export default QRRedirectOS;



// WEBPACK FOOTER //
// ./components/common/QRRedirectOS.js